export const isScreenSmall = () => {
  return window.innerWidth <= 767
}

export const isScreenMedium = () => {
  return window.innerWidth > 767 && window.innerWidth <= 1024
}

export const isScreenBig = () => {
  return window.innerWidth > 1024
}

export const isMobile = () => {
  return matchMedia('(max-width: 600px)').matches
}

export const getMargin = (size, isTop) => {
  return size === 'Large'
    ? `u-margin${isTop ? 'Top' : 'Bottom'}12gu`
    : size === 'Medium'
      ? `u-margin${isTop ? 'Top' : 'Bottom'}8gu`
      : size === 'Small'
        ? `u-margin${isTop ? 'Top' : 'Bottom'}4gu`
        : size === 'Extra Small'
          ? `u-margin${isTop ? 'Top' : 'Bottom'}2gu`
          : ''
}

export const getMargins = (marginTop, marginBottom) => {
  return `${getMargin(marginTop, true)} ${getMargin(marginBottom, false)}`
}
